export enum UserRole {
    Admin = 1,
    Manager = 2,
    User = 3,
}

export type TUser = {
    id?: number,
    name: string,
    surname: string,
    email: string,
    group: UserRole,
    password?: string
}

export type TUserUpdate = TUser & { login: string }

export type TAccount = TUser & { 'x-device-code'?: string }
